import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	descriptionLabel: {
		id: 'software-releases-approvers.task-approver.approval-drawer.approval-description.description-label',
		defaultMessage: 'Description',
		description: 'The label of the description field',
	},
	descriptionAriaLabel: {
		id: 'software-releases-approvers.task-approver.approval-drawer.approval-description.description-aria-label',
		defaultMessage: 'Edit description',
		description: 'The aria label of the description field',
	},
	descriptionEditConfirmLabel: {
		id: 'software-releases-approvers.task-approver.approval-drawer.approval-description.description-edit-confirm-label',
		defaultMessage: 'Save description change',
		description: 'The icon label of the confirmation button.',
	},
	descriptionEditCancelLabel: {
		id: 'software-releases-approvers.task-approver.approval-drawer.approval-description.description-edit-cancel-label',
		defaultMessage: 'Cancel description change',
		description: 'The icon label of the cancelation button.',
	},
	noDescriptionPlaceholder: {
		id: 'software-releases-approvers.task-approver.approval-drawer.approval-description.no-description-placeholder',
		defaultMessage: 'No description added',
		description: 'The placeholder to show that description does not exist yet',
	},
	updateDescriptionFailed: {
		id: 'software-releases-approvers.task-approver.approval-drawer.approval-description.update-description-failed',
		defaultMessage: 'Failed to update the reason. Please re-try.',
		description: 'The flag message to show when updating the description failed',
	},
});
